
var backendRoute = {
    data : 'https://api.teamcomunicaciones.com.co/api/v1.0/'
    //data : 'http://localhost:8000/api/v1.0/'
}

export default backendRoute;    